import React from 'react';
import { Link } from 'react-router-dom';
import {
  PiArrowUpRightLight,
  PiFileTextLight,
  PiGraduationCapLight,
  PiShieldCheckLight,
} from 'react-icons/pi';
import { HomeTitle } from './HomeSectionHead';

// "Guided start" (2026-10-15, ui-ux-pro-max option of three): one primary
// action for freelancers, with the three steps beside it so "is this hard, is
// it safe?" is answered before the click. Listing is free; the commission
// isn't mentioned here (2026-10-19), the fee pages cover it.
const STEPS = [
  { icon: PiFileTextLight, title: 'List what you do', note: 'Set your own price and packages.' },
  { icon: PiGraduationCapLight, title: 'Verify your university', note: 'Clients see the verified badge.' },
  { icon: PiShieldCheckLight, title: 'Get paid safely', note: 'The client pays up front and it’s held in escrow.' },
];

// Closing marketplace CTA for the marketing homepage (Home.jsx). White, as
// approved in the mockup, so it doesn't stack on the dark footer island.
export default function HomeClosingCTA() {
  const body = (
    <div className="mx-auto grid max-w-[1080px] items-center gap-10 text-left lg:grid-cols-[1.1fr_1fr] lg:gap-16">
      <div>
        {/* "earn" in gold, normal weight (the user's call, 2026-10-19). brass-dark,
            not brass: plain brass is ~2.3:1 on white, brass-dark ~3.9:1, which
            passes for text this large. */}
        <HomeTitle
          display
          title={<>What could you <span className="text-press-brass-dark">earn</span> from what you know?</>}
          className="max-w-[560px]"
        />
        <p className="mt-4 max-w-[46ch] text-desc text-press-muted">Listing a service is free.</p>
        <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-3">
          <Link to="/find-work" className="btn-island btn-island--ink">
            Post a service
            <span className="btn-island-ic"><PiArrowUpRightLight size={17} aria-hidden="true" /></span>
          </Link>
          <Link
            to="/hire-talent"
            className="text-[14px] font-semibold text-press-ink underline decoration-press-ink/30 underline-offset-4 transition hover:decoration-press-ink"
          >
            or browse services
          </Link>
        </div>
      </div>

      <ol className="overflow-hidden rounded-2xl border border-press-border bg-press-card">
        {STEPS.map(({ icon: Icon, title, note }, i) => (
          <li key={title} className={`flex items-start gap-4 p-5 ${i ? 'border-t border-press-border' : ''}`}>
            <span className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-press-paper-2 text-press-ink">
              <Icon size={20} aria-hidden="true" />
            </span>
            <div>
              <p className="text-[15px] font-semibold text-press-ink">
                <span className="sr-only">Step {i + 1}: </span>{title}
              </p>
              <p className="mt-0.5 text-[14px] text-press-muted">{note}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );

  return (
    <section className="mx-auto max-w-page px-6 py-20 sm:px-10 sm:py-24 lg:px-16" aria-label="Start selling">
      {body}
    </section>
  );
}
